import { Component } from '@angular/core';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { TrainingFunctions } from '../functions/trainingFunctions';
import { QtHistory } from './trainingCommon';
import { HrEmployees } from '../../../../models';
import { AimsCommonPopupEditorComponent, AimsCommonTableHeader, AimsCommonTableHeaderType } from '@aims/common-components';
import { TrainingBaseComponent } from './training-base.component';
import { MatDialog } from '@angular/material/dialog';
import { CompletedTrainingDialogComponent } from './completed-training-dialog/completed-training-dialog.component';


@Component({
  selector: 'myTraining',
  templateUrl: './training.component.html',
  styleUrls: ['../hr.component.css'],
  providers: [TrainingFunctions]
})

export class MyTrainingComponent extends TrainingBaseComponent {

  constructor(private transferHttp: TransferHttpService,
    private router: Router,
    public permissions: PermissionsService,
    private dialog: MatDialog,
    public tFunc: TrainingFunctions) {
      super();
  }

  ALL_TRAINING = 0;
  INDIVIDUALLY_ASSIGNED = 1;
  GENERAL = 2;
  JOB_TITLE = 3;
  EMP_JOB_ASSIGNMENT = 4;
  OTHER_JOB_TITLE = 5;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  showIndAssigned: boolean = false;
  showGenAssigned: boolean = false;
  showJtAssigned: boolean = false;
  showOjtAssigned: boolean = false;
  showJaAssigned: boolean = false;

  isSelfTrained: boolean = false;
  ettQualTaskId: number = null;
  hasJtRequirements: boolean = false;
  countOccs: number = 0;

  headerText: string = 'My Training';
  routedFrom: string = 'myTraining';

  //Dropdowns
  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
  activeEmployeeValues = this.transferHttp.getHot('Common/GetActiveEmployeesForDropDown');
  workSectionValues = this.transferHttp.getHot('Common/GetAllWorksectionsForDropdown');
  jobTitleValues = this.transferHttp.getHot('Common/GetAllJobTitlesForDropdown');
  employeeJobAssignmentValues = this.transferHttp.getHot('Common/GetAllEmployeeJobAssignmentsForDropdown');

  qualTaskTrainerValues = this.transferHttp.getHot('Tr/GetQualTaskTrainers');
  qualificationValues = this.transferHttp.getHot('Tr/GetQualsForDropDown');
  qualificationTaskValues = this.transferHttp.getHot('Tr/GetQualTasksForDropDown');
  qualTaskValues = this.transferHttp.getHot(`Tr/GetQualTasksForDropDown`);
  trainerValues = this.transferHttp.getHot(`Tr/GetTrainers`);

  //New Popup
  newQtHistory: QtHistory = new QtHistory;

  //***************************
  // Training Variables
  //***************************
  user = this.transferHttp.getCache<HrEmployees>('user');
  empId = this.user.employeeId;
  empFullName = this.user.fullName;

  qualSource: number = this.ALL_TRAINING;

  //Grid config
  indAssignedTraining = this.transferHttp.getHot(`Tr/GetIndAssignedTraining?empId=${this.empId}`);
  generalTraining = this.transferHttp.getHot(`Tr/GetGeneralTraining?empId=${this.empId}`);
  jobTitleTraining = this.transferHttp.getHot(`Tr/GetJobTitleTraining?empId=${this.empId}`);
  otherJobTitleTraining = this.transferHttp.getHot(`Tr/GetOtherJobTitleTraining?empId=${this.empId}`);
  jobAssignmentTraining = this.transferHttp.getHot(`Tr/GetJobAssignmentTraining?empId=${this.empId}`);

  allQttValues = [];
  filteredQttValues = [];

  allActiveEmpValues = [];
  filteredEmpValues = [];

  public printCurrentHistory(empId: number) {
    this.router.navigate([`reporting/TR_CurrentTrainingHistoryByEmp/trdp/{"empID":"${empId}"}`]);
  }

  public printOccJobTitleHistory(empId: number) {
    this.router.navigate([`reporting/TR_TrainingHistoryByEmpAndOcc/trdp/{"empID":"${empId}"}`]);
  }

  public printMyOverdueOrComingDueTraining(empId: number) {
    this.router.navigate([`reporting/TR_MyOverdueOrComingDueTraining/trdp/{"empID":"${empId}"}`]);
  }

  public checkExsits(): void {
    this.indAssignedTraining.subscribe(result => {
      if (result.length == 0) {
        this.showIndAssigned = false;
      }
      else {
        this.showIndAssigned = true;
      }
    });

    this.generalTraining.subscribe(result => {
      if (result.length == 0) {
        this.showGenAssigned = false;
      }
      else {
        this.showGenAssigned = true;
      }
    });

    this.jobTitleTraining.subscribe(result => {
      if (result.length == 0) {
        this.showJtAssigned = false;
      }
      else {
        this.showJtAssigned = true;
      }
    });

    this.otherJobTitleTraining.subscribe(result => {
      this.countOccs = result.length;

      if (this.countOccs == 0) {
        this.hasJtRequirements = false;
        this.showOjtAssigned = false;
      }
      else {
        this.hasJtRequirements = true;
        this.showOjtAssigned = true;
      }
    });
    this.jobAssignmentTraining.subscribe(result => {
      if (result.length == 0) {
        this.showJaAssigned = false;
      }
      else {
        this.showJaAssigned = true;
      }
    });

  }

  public updateTraining(masterQtHs: any, qualSource: number) {
    this.qualSource = qualSource;
    this.newQtHistory = new QtHistory();

    this.newQtHistory.qualTaskId = masterQtHs.qualTaskId;
    this.newQtHistory.employeeId = this.empId;
    this.newQtHistory.revoked = false;

    this.filteredQttValues = this.allQttValues.filter(qqt => qqt.qualTaskId == this.newQtHistory.qualTaskId && qqt.active);

    if (this.filteredQttValues.length <= 0) {
      this.isSelfTrained = true;
      this.newQtHistory.trainedById = this.empId;
    }

    this.newQtHistory.qtHistoryId = masterQtHs.qtHistoryId;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      data: {
        header: '',
        content: CompletedTrainingDialogComponent,
        contentData: { newQtHistory: this.newQtHistory, isSelfTrained: this.isSelfTrained,
                       filteredQttValues: this.filteredQttValues, employeeValues: this.employeeValues                 },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newQtHistory.completedOn = dialogResult.completedOn;
        if (!this.isSelfTrained ) {
          this.newQtHistory.trainedById = dialogResult.trainedById;
        }

        if (this.newQtHistory.completedOn != null && this.newQtHistory.trainedById != null) {
          this.saveNewQtHistory(this.newQtHistory);
        }
      }
      else {
        this.cancelNewQtHistory();
      }
    });

  }

  public cancelNewQtHistory(): void {
    this.isSelfTrained = false;
  }

  public saveNewQtHistory(newQtHistory: QtHistory): void {
    this.spinnerText = "Saving Qual Task History...";
    this.showSpinner = true;

    this.filteredEmpValues = this.allActiveEmpValues.filter(e => e.employeeId == newQtHistory.trainedById);

    this.transferHttp.post(`Tr/SaveQualTaskHistory`, newQtHistory).subscribe(show => {

      this.refreshTraining(this.qualSource);
      this.showSpinner = false;
    });

  }

  public refreshTraining(qualSource: number) {

    if (qualSource == this.ALL_TRAINING) {
      this.indAssignedTraining = this.transferHttp.getHot(`Tr/GetIndAssignedTraining?empId=${this.empId}`);
      this.generalTraining = this.transferHttp.getHot(`Tr/GetGeneralTraining?empId=${this.empId}`);
      this.jobTitleTraining = this.transferHttp.getHot(`Tr/GetJobTitleTraining?empId=${this.empId}`);
      this.otherJobTitleTraining = this.transferHttp.getHot(`Tr/GetOtherJobTitleTraining?empId=${this.empId}`);
      this.jobAssignmentTraining = this.transferHttp.getHot(`Tr/GetJobAssignmentTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.INDIVIDUALLY_ASSIGNED) {
      this.indAssignedTraining = this.transferHttp.getHot(`Tr/GetIndAssignedTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.GENERAL) {
      this.generalTraining = this.transferHttp.getHot(`Tr/GetGeneralTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.JOB_TITLE) {
      this.jobTitleTraining = this.transferHttp.getHot(`Tr/GetJobTitleTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.OTHER_JOB_TITLE) {
      this.otherJobTitleTraining = this.transferHttp.getHot(`Tr/GetOtherJobTitleTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.EMP_JOB_ASSIGNMENT) {
      this.jobAssignmentTraining = this.transferHttp.getHot(`Tr/GetJobAssignmentTraining?empId=${this.empId}`);
    }
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {

    this.checkExsits();

    this.workSectionValues.subscribe();
    this.activeEmployeeValues.subscribe(data => { this.allActiveEmpValues = data; });
    this.qualTaskTrainerValues.subscribe(data => { this.allQttValues = data; });
    this.qualificationValues.subscribe();
    this.qualTaskValues.subscribe(data => {
      var x = data;
      });
    this.trainerValues.subscribe();
  }

}
